import type { JsonQuestion } from './types';
import type { JsonAnswerValue } from './QuestionRenderer';

/**
 * Returns whether the question should be treated as required for validation and UI.
 * When skipRequiredWhen is set, the question is not required if the dependency
 * question's answer is one of the configured values (e.g. "Skipped breakfast").
 */
export function isEffectivelyRequired(
  question: JsonQuestion,
  getAnswer: (dependencyQuestionId: string) => JsonAnswerValue
): boolean {
  const baseRequired = question.validation?.required === true || question.isRequired === true;
  if (!baseRequired) return false;
  const skip = question.skipRequiredWhen;
  if (!skip) return true;
  const depAnswer = getAnswer(skip.questionId);
  const depValues = Array.isArray(depAnswer)
    ? depAnswer
    : typeof depAnswer === 'string'
      ? [depAnswer]
      : [];
  const valueSet = new Set(skip.values.map((v) => v.trim()));
  const shouldSkip = depValues.some(
    (v) => typeof v === 'string' && valueSet.has(v.trim())
  );
  return !shouldSkip;
}
